import ExcelJS from 'exceljs';
import saveAs from 'file-saver';
import { exportDataGrid } from 'devextreme/excel_exporter';

const getItemScopedIndex = (dgInstance, rowData) => {
  const dgItems = dgInstance._controllers.data._items;
  const { Id } = rowData.current;

  if (!Id) return -1;

  return dgItems.findIndex(({ key }) => key === Id);
};

const createRowIndexAction = (actionCb) => ({ dgInstance, rowData }) => {
  const rowIndex = getItemScopedIndex(dgInstance, rowData);

  return actionCb(dgInstance, rowIndex);
};

export const editButton = createRowIndexAction((dgInstance, rowIndex) => {
  dgInstance.editRow(rowIndex);
});

export const magnifierButton = createRowIndexAction((dgInstance, rowIndex) => {
  dgInstance.editRow(rowIndex);
});

export const actionButton = (dgInstance, rowData) => {
  const rowIndex = getItemScopedIndex(dgInstance, rowData);

  dgInstance.editRow(rowIndex);
};

export const deleteButton = createRowIndexAction((dgInstance, rowIndex) => {
  dgInstance.deleteRow(rowIndex);
});

export const refreshButton = ({ dgInstance }) => {
  dgInstance.refresh();
};

const handleAction = (setAction, action, newAction) => {
  if (action === newAction) {
    setAction(`_${newAction}`);
  } else {
    setAction(newAction);
  }
};

export const addButton = ({ setAction, action }) => {
  handleAction(setAction, action, 'ADD');
};

export const copyButton = ({ setAction, action, rowData, dgInstance }) => {
  const rowIndex = getItemScopedIndex(dgInstance, rowData);

  if (rowIndex !== -1) {
    handleAction(setAction, action, 'COPY');
  }
};

export const importButton = (setAction, action) => {
  handleAction(setAction, action, 'IMPORT');
};

export const additionalActionButton = (setAction, action) => {
  handleAction(setAction, action, 'TREEVIEW');
};

const getProperFormatDatePart = (date) => {
  if (date < 10) {
    return `0${date}`;
  }

  return date;
};

const setColsVisibility = (component, cols, visible) => {
  cols.forEach((dataField) => {
    component.columnOption(dataField, 'visible', visible);
  });
};

const exportToExcel = (component, setIsLoadingPanelVisible, title) => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet('Main sheet');
  const convertedTitle = title.replace(/\s+/g, '_').toLowerCase();
  const currentDate = new Date();
  const month = getProperFormatDatePart(currentDate.getMonth() + 1);
  const year = currentDate.getFullYear();
  const day = getProperFormatDatePart(currentDate.getDate());
  const hour = getProperFormatDatePart(currentDate.getHours());
  const minute = getProperFormatDatePart(currentDate.getMinutes());

  const fileNameDate = `${year}${month}${day}_${hour}${minute}`;

  component.beginUpdate();

  const notVisibleCols = component
    .option('columns')
    .filter((x) => x.visible === false && x.dataField)
    .map((x) => x.dataField);

  setColsVisibility(component, notVisibleCols, true);

  setIsLoadingPanelVisible(true);

  exportDataGrid({
    component,
    worksheet,
    customizeCell: (options) => {
      const excelCell = options;
      excelCell.font = { name: 'Arial', size: 12 };
      excelCell.alignment = { horizontal: 'left' };
    },
    catch: (e) => console.log(e),
    loadPanel: {
      enabled: false
    }
  })
    .then(() => {
      workbook.xlsx.writeBuffer().then((buffer) => {
        saveAs(
          new Blob([buffer], { type: 'application/octet-stream' }),
          `${convertedTitle}_${fileNameDate}.xlsx`
        );
        setIsLoadingPanelVisible(false);
      });
    })
    .then(() => {
      setColsVisibility(component, notVisibleCols, false);
      component.endUpdate();
    });
};

export const exportButton = ({
  dgInstance,
  setIsLoadingPanelVisible,
  title
}) => {
  exportToExcel(dgInstance, setIsLoadingPanelVisible, title);
};
